var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24ActionsFuals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-actions-_fuals",
    "data-name": "icon-24-actions- fuals",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm2.21,11.242a.481.481,0,0,1-.35-.152L10,11.24,8.14,13.09a.478.478,0,0,1-.7,0l-.53-.529a.479.479,0,0,1,0-.7L8.76,10,6.91,8.14a.478.478,0,0,1,0-.7l.53-.53a.478.478,0,0,1,.7,0L10,8.76l1.86-1.85a.479.479,0,0,1,.7,0l.529.53a.478.478,0,0,1,0,.7L11.24,10l1.849,1.86a.479.479,0,0,1,0,.7l-.529.529A.481.481,0,0,1,12.21,13.242Z",
    transform: "translate(2 2)",
    fill: "#ff3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24ActionsFuals);
export default __webpack_public_path__ + "static/media/icon-24-actions- fuals.6246740c2d1e72e1f6caf77f24093bb3.svg";
export { ForwardRef as ReactComponent };